export interface CopyableThread {
	id: string
	number: number | null | undefined
	title: string | null | undefined
}

export function threadUrl(origin: string, threadId: string) {
	return `${origin}/threads/${threadId}`
}

export function threadLinkLabel(thread: CopyableThread) {
	const title = thread.title?.trim()
	const number = thread.number != null ? `#${thread.number}` : null
	if (number && title) return `${number} ${title}`
	return number ?? title ?? "Untitled thread"
}

const escapeHtml = (value: string) =>
	value
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")

const escapeMarkdownLabel = (value: string) => value.replace(/[[\]\\]/g, "\\$&")

export function threadTitleLink(thread: CopyableThread, origin: string) {
	const url = threadUrl(origin, thread.id)
	const label = threadLinkLabel(thread)
	return {
		text: `[${escapeMarkdownLabel(label)}](${url})`,
		html: `<a href="${escapeHtml(url)}">${escapeHtml(label)}</a>`,
	}
}

/** ⌘C copies the thread link only when nothing is selected, so copying message text keeps working. */
export function hasTextSelection(selection: Selection | null) {
	return !!selection && !selection.isCollapsed && !!selection.toString().trim()
}
